module.exports = __webpack_public_path__ + "static/900_450_crop-7c7eba2f0efd002062b80cec4322fa8c.jpg";